module.exports = __webpack_public_path__ + "img/bg-cost.9be03adf.png";